import {
  DepositTakerAndCurrencies,
  GroupedPassedItem,
  Leg
} from '@approot/models';
import {
  clearTextColor,
  disableAndWipeAttribute,
  optionsChangeHandler
} from './leg.utilities';
import { FormGroup } from '@angular/forms';
import { getAttributeControlFromKey } from './leg-attribute-utilities';
import { clearFirstEditedDcdAttribute } from './dcd-utilities';

export function tradePremiumValuationAdjustmentCurrency(
  currencies: GroupedPassedItem[],
  attributeField: string,
  form: FormGroup,
  leg: Leg,
  presetsLoaded: boolean,
  useDefaults: boolean
) {
  const useSetDefault = // are we using default valuationAdjustmentCurrency
    presetsLoaded &&
    leg.preSetPosition &&
    leg.preSetPosition[attributeField] &&
    currencies.includes(leg.preSetPosition[attributeField]);

  optionsChangeHandler(
    form,
    leg,
    attributeField,
    currencies,
    presetsLoaded
      ? useSetDefault // if presets are loaded and we are using default
        ? leg.preSetPosition[attributeField]
        : currencies.length && useDefaults // presets are loaded but we are not using defaults
        ? currencies[0].items[0] // there are currencies available use first one
        : null // set a empty
      : form.get(attributeField).value
  );
}

export function depositTakersAndCurrenciesChanges(
  depositTakersAndCurrencies: DepositTakerAndCurrencies[],
  form: FormGroup,
  leg: Leg
): void {
  const currDepositTaker = form.get('depositTaker').value;
  const currDepositCurrency = form.get('depositCurrency').value;
  const depositTakers = depositTakersAndCurrencies.map(x => x.entity);
  const depositCurrencies =
    depositTakersAndCurrencies.find(curve => curve.entity === currDepositTaker)
      ?.currencies || [];

  optionsChangeHandler(
    form,
    leg,
    'depositTakers',
    depositTakers,
    depositTakers.includes(currDepositTaker) ? currDepositTaker : ''
  );

  optionsChangeHandler(
    form,
    leg,
    'depositCurrency',
    depositCurrencies,
    depositCurrencies.includes(currDepositCurrency) ? currDepositCurrency : ''
  );
}

export function depositTakerChanges(
  val: string,
  form: FormGroup,
  leg: Leg,
  depositTakersAndCurrencies: DepositTakerAndCurrencies[]
) {
  const depositCurrencies =
    depositTakersAndCurrencies.find(curve => curve.entity === val)
      ?.currencies || [];

  optionsChangeHandler(form, leg, 'depositCurrency', depositCurrencies, ''); // load the deposit currencies options on deposit taker change
}

export function depositRateChanges(
  form: FormGroup,
  leg: Leg,
  presetsLoaded: boolean
) {
  const isReadonly = getAttributeControlFromKey(
    'depositRate',
    leg.attributesAsFormControls
  ).readOnly;
  if (presetsLoaded && !isReadonly) {
    if (leg.missingAttributeOnPricing === 'depositRate') {
      // if we are changing the attribute that was missing
      clearTextColor(leg, 'depositRate'); // remove color from text
      leg.missingAttributeOnPricing = '';
    } else if (form.get(leg.missingAttributeOnPricing)) {
      // wipe the missing attribute value as its no longer correct
      form
        .get(leg.missingAttributeOnPricing)
        .setValue('', { emitEvent: false });
    }
    // tslint:disable-next-line: max-line-length
    clearFirstEditedDcdAttribute('depositRate', leg, form); // wipe values if more than 2 fields have values (margin, conversion rate and deposit rate)
  }
}

export function forceCashSettlementChange(val: string, form: FormGroup) {
  if (val === 'True') {
    form.get('forcedCashSettlementCurrency')?.enable();
    form.get('forcedCashSettlementFixingSource')?.enable();
  } else {
    disableAndWipeAttribute('forcedCashSettlementCurrency', form);
    disableAndWipeAttribute('forcedCashSettlementFixingSource', form);
  }
}
